import { ChartType, Html } from "@custom/schema";
import { ArcElement, BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Title, Tooltip } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import clsx from "clsx";
import React from "react";
import { Bar, Pie } from "react-chartjs-2";
ChartJS.register(ArcElement, ChartDataLabels, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);
export function ParagraphChart(props) {
    return /*#__PURE__*/ React.createElement("div", {
        className: "prose text-center container-page paragraph-container"
    }, props.title && /*#__PURE__*/ React.createElement("h2", {
        className: clsx({
            "mb-8 md:mb-12": props.type === ChartType.Bar
        }, {
            "mb-0 md:mb-4": props.type === ChartType.Pie
        })
    }, props.title), props.data && (props.type === ChartType.Pie ? /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center h-[15rem] md:h-[30rem] justify-center overflow-x-auto w-full"
    }, /*#__PURE__*/ React.createElement(PieChart, props)) : /*#__PURE__*/ React.createElement("div", {
        className: "overflow-x-auto"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "md:w-[90vw] relative min-w-[40rem] h-[80vh]"
    }, /*#__PURE__*/ React.createElement(HorizontalBar, props)))), /*#__PURE__*/ React.createElement("div", {
        className: "mt-8 md:mt-12"
    }, " ", props.description && /*#__PURE__*/ React.createElement(Html, {
        markup: props.description
    }), " "));
}
var PieChart = function(props) {
    var _props_data, _props_data1;
    var _props_data_map, _props_data_map1;
    var data = {
        labels: (_props_data_map = (_props_data = props.data) === null || _props_data === void 0 ? void 0 : _props_data.map(function(item) {
            var _item;
            return (_item = item) === null || _item === void 0 ? void 0 : _item.text;
        })) !== null && _props_data_map !== void 0 ? _props_data_map : [],
        datasets: [
            {
                data: (_props_data_map1 = (_props_data1 = props.data) === null || _props_data1 === void 0 ? void 0 : _props_data1.map(function(item) {
                    var _item;
                    return (_item = item) === null || _item === void 0 ? void 0 : _item.value;
                })) !== null && _props_data_map1 !== void 0 ? _props_data_map1 : [],
                backgroundColor: [
                    "#33AB66",
                    "#A1D5B2"
                ],
                hoverOffset: 8
            }
        ]
    };
    return /*#__PURE__*/ React.createElement(Pie, {
        data: data,
        options: {
            elements: {
                arc: {
                    borderWidth: 0
                }
            },
            responsive: true,
            plugins: {
                legend: {
                    display: true,
                    position: "bottom",
                    labels: {
                        padding: 24,
                        color: "#000000"
                    }
                },
                title: {
                    display: true
                },
                datalabels: {
                    labels: {
                        title: {
                            color: "#000000",
                            formatter: function formatter(value, ctx) {
                                var _ctx_chart_data_datasets_, _datapoints;
                                var datapoints = (_ctx_chart_data_datasets_ = ctx.chart.data.datasets[0]) === null || _ctx_chart_data_datasets_ === void 0 ? void 0 : _ctx_chart_data_datasets_.data;
                                var total = (_datapoints = datapoints) === null || _datapoints === void 0 ? void 0 : _datapoints.reduce(function(total, datapoint) {
                                    return total + datapoint;
                                });
                                var percentage = value / total * 100;
                                return percentage.toFixed(1) + "%";
                            }
                        }
                    }
                }
            }
        }
    });
};
var HorizontalBar = function(props) {
    var _props_data, _props_data1;
    var _props_data_map, _props_data_map1;
    var data = {
        labels: (_props_data_map = (_props_data = props.data) === null || _props_data === void 0 ? void 0 : _props_data.map(function(item) {
            var _item;
            return (_item = item) === null || _item === void 0 ? void 0 : _item.text;
        })) !== null && _props_data_map !== void 0 ? _props_data_map : [],
        datasets: [
            {
                data: (_props_data_map1 = (_props_data1 = props.data) === null || _props_data1 === void 0 ? void 0 : _props_data1.map(function(item) {
                    var _item;
                    return (_item = item) === null || _item === void 0 ? void 0 : _item.value;
                })) !== null && _props_data_map1 !== void 0 ? _props_data_map1 : [],
                backgroundColor: [
                    "#33AB66"
                ]
            }
        ]
    };
    return /*#__PURE__*/ React.createElement(Bar, {
        data: data,
        options: {
            maintainAspectRatio: false,
            indexAxis: "y",
            elements: {
                bar: {
                    borderWidth: 0
                }
            },
            responsive: true,
            plugins: {
                datalabels: {
                    labels: {
                        title: null
                    }
                },
                legend: {
                    display: false
                },
                title: {
                    display: false
                }
            }
        }
    });
};
